import { connect } from '@atlassian/jira-react-redux';
import { projectNameSelector } from '../../../state/entities/selectors';
import type { AppState } from '../../../state/types';
import { deleteProject, closeDeleteProjectModal } from '../../../state/ui/actions';
import { isDeletingSelector } from '../../../state/ui/selectors';
import DeleteProject from './view';

const mapStateToProps = (state: AppState) => ({
	isDeleting: isDeletingSelector(state),
	projectName: projectNameSelector(state),
});

const mapDispatchToProps = {
	onDelete: deleteProject,
	onClose: closeDeleteProjectModal,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(DeleteProject);
